module.exports = __webpack_public_path__ + "static/media/pingpong.f30aefa5.jpeg";